/**
 * Video Calls API Service
 */

import apiClient from '../client';
import type {
  VideoCallMeeting,
  StartMeetingRequest,
  StartMeetingResponse,
  EndedMeeting,
} from '../types/videocall.types';

const BASE_URL = '/videocalls';

export const videocallsService = {
  /**
   * Start a new video call meeting
   */
  startMeeting: async (
    data: StartMeetingRequest
  ): Promise<StartMeetingResponse> => {
    const response = await apiClient.post<StartMeetingResponse>(
      `${BASE_URL}/start`,
      data
    );
    return response.data;
  },

  /**
   * End an active meeting
   */
  endMeeting: async (meetingId: string): Promise<EndedMeeting> => {
    const response = await apiClient.post<EndedMeeting>(
      `${BASE_URL}/id/${meetingId}/end`
    );
    return response.data;
  },

  /**
   * Get list of active meetings
   */
  getActiveMeetings: async (): Promise<VideoCallMeeting[]> => {
    const response = await apiClient.get<VideoCallMeeting[]>(
      `${BASE_URL}/active`
    );
    return response.data;
  },

  /**
   * Get meeting details by ID
   */
  getMeeting: async (meetingId: string): Promise<VideoCallMeeting> => {
    const response = await apiClient.get<VideoCallMeeting>(
      `${BASE_URL}/id/${meetingId}`
    );
    return response.data;
  },
};
